import React, { useEffect, useState } from 'react';
import { Icon, Wordmark } from '../components/sp-primitives';
import { useApp } from '../components/sp-shell';

const LAYOUT_CACHE_KEY = 'sp_login_layout_cache';

const LOGIN_LAYOUT_DEFAULTS = {
  wm_brand: 'SIENGE', wm_accent: 'PAY',
  hero_kicker: '— Conecte seu time de RH ao Sienge',
  hero_title: 'Seus pagamentos,\nintegrados ao Sienge',
  hero_accent: 'de um jeito amigável.',
  hero_lead: 'Middleware multi-empresa que audita, concilia e envia pagamentos ao ERP com segurança e rastreabilidade.',
  hero_footer: '© FullTec Engenharia · 2026',
};

function readLayoutCache() {
  try {
    const raw = localStorage.getItem(LAYOUT_CACHE_KEY);
    return raw ? { ...LOGIN_LAYOUT_DEFAULTS, ...JSON.parse(raw) } : null;
  } catch { return null; }
}

function writeLayoutCache(data) {
  try { localStorage.setItem(LAYOUT_CACHE_KEY, JSON.stringify(data)); } catch { /* ignore */ }
}

export function PLogin() {
  const app = useApp();
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [layout, setLayout] = useState(() => readLayoutCache() || LOGIN_LAYOUT_DEFAULTS);

  useEffect(() => {
    app.fetchLoginLayout().then((data) => {
      if (data) {
        const merged = { ...LOGIN_LAYOUT_DEFAULTS, ...data };
        setLayout(merged);
        writeLayoutCache(merged);
      }
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async (e) => {
    e && e.preventDefault();
    setLoading(true);
    try {
      await app.login(email, pwd);
      setLoading(false);
      app.navigate('dashboard');
      app.toast('success', 'Bem-vindo!', 'Login efetuado com sucesso.');
    } catch (error) {
      setLoading(false);
      app.toast('error', 'Falha no login', error.message || 'Verifique suas credenciais.');
    }
  };

  return (
    <div className="sp-art sp-A sp-login">
      <div className="sp-login__hero">
        <Wordmark size={20} brand={layout.wm_brand} accent={layout.wm_accent} />
        <div>
          <div className="sp-caps sp-login__hero-kicker" dangerouslySetInnerHTML={{ __html: layout.hero_kicker }} />
          <h1 className="sp-login__hero-title">
            <span dangerouslySetInnerHTML={{ __html: layout.hero_title }} />
            <br /><span className="sp-login__hero-accent" dangerouslySetInnerHTML={{ __html: layout.hero_accent }} />
          </h1>
          <p className="sp-login__hero-lead" dangerouslySetInnerHTML={{ __html: layout.hero_lead }} />
        </div>
        <div className="sp-login__hero-footer" dangerouslySetInnerHTML={{ __html: layout.hero_footer }} />
      </div>
      <div className="sp-login__panel">
        <form className="sp-login__form" onSubmit={submit}>
          <h2 className="sp-login__form-title">Entrar</h2>
          <div className="sp-login__form-lead">Acesse com sua conta FullTec.</div>
          <label className="sp-caps sp-login__label">E-mail corporativo</label>
          <input className="sp-input sp-login__field" value={email} onChange={(e) => setEmail(e.target.value)} />
          <label className="sp-caps sp-login__label">Senha</label>
          <div className="sp-login__pwd-wrap">
            <input className="sp-input" type={showPwd ? 'text' : 'password'} value={pwd} onChange={(e) => setPwd(e.target.value)} />
            <button type="button" className="sp-login__pwd-toggle" onClick={() => setShowPwd((s) => !s)}><Icon name="eye" size={14} /></button>
          </div>
          <label className="sp-login__remember">
            <input type="checkbox" /> Manter conectado neste dispositivo
          </label>
          <button type="submit" disabled={loading} className="sp-btn sp-btn-accent sp-login__submit">
            {loading ? 'Entrando…' : 'Entrar'}
          </button>
          <div className="sp-login__forgot-wrap">
            <button type="button" className="sp-btn sp-btn-ghost sp-login__forgot" onClick={() => app.toast('info', 'Recuperação de senha', 'Instruções enviadas para seu e-mail.')}>Esqueci minha senha</button>
          </div>
          {app.isSyncing && (
            <div className="sp-login__sync">
              Sincronizando dados da API...
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
